import { render, staticRenderFns } from "./_GenericCard.vue?vue&type=template&id=4aa312d8&"
import script from "./_GenericCard.vue?vue&type=script&lang=js&"
export * from "./_GenericCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports